module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Comments"},"de":{"title":"Kommentare"},"fr":{"title":"Commentaires"},"it":{"title":"Commenti"}}')
  delete Component.options._Ctor
}
